// src/components/job-engine/StatePill.tsx
import React from "react";
import { Text } from "@fluentui/react";
import { stateColor, stateLabel } from "./formatters";
import type { JobState } from "@/api/jobEngine";

interface Props { state: JobState; }

const StatePill: React.FC<Props> = ({ state }) => {
  const color = stateColor(state);
  return (
    <Text
      styles={{
        root: {
          display: "inline-block",
          padding: "2px 8px",
          borderRadius: 10,
          color: "white",
          backgroundColor: color,
          fontSize: 12,
          fontWeight: 600,
        },
      }}
    >
      {stateLabel(state)}
    </Text>
  );
};

export default StatePill;
